import { computed, inject, provide, Ref } from "vue";
import { injectCarouselContext } from "../lib/provideInjectors";
import { Dimensions } from "@fresh8/vue-utils/src/dimensionSync";
import { injectAdSize } from "./useAdSize";

export const SQUARISH = "squarish";
export const LANDSCAPE = "landscape";
export const STRAPLINE = "strapline";

export function useLayout(dimensions: Ref<Dimensions> = injectAdSize()) {
  const carouselContext = injectCarouselContext();

  const layout = computed(() => {
    const { width, height } = dimensions.value;

    if (carouselContext.value) {
      if (height < 200) {
        return STRAPLINE;
      }
      return SQUARISH;
    }

    if (width <= 400) {
      if (height < 200) {
        return STRAPLINE;
      }
      return SQUARISH;
    } else {
      if (height < 200) {
        return STRAPLINE;
      }
      return LANDSCAPE;
    }
  });

  return {
    dimensions,
    layout,
    SQUARISH
  };
}

export type LayoutContext = ReturnType<typeof useLayout>;
export const LayoutSymbol = Symbol("LayoutSymbol");

export function provideLayout(layoutContext: LayoutContext) {
  return provide(LayoutSymbol, layoutContext);
}
export function injectLayout(): LayoutContext | undefined {
  return inject<LayoutContext>(LayoutSymbol);
}
